import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { grafikService } from '../../services/grafikService';
import { toISODate } from '../../utils/grafikHelpers';

const LEAVE_TYPES = [
  { value: 'urlop_wypoczynkowy', label: 'Urlop wypoczynkowy' },
  { value: 'urlop_na_zadanie', label: 'Urlop na zadanie' },
  { value: 'urlop_okolicznosciowy', label: 'Urlop okolicznosciowy' },
  { value: 'urlop_macierzynski', label: 'Urlop macierzynski' },
  { value: 'urlop_rodzicielski', label: 'Urlop rodzicielski' },
  { value: 'urlop_bezplatny', label: 'Urlop bezplatny' }
];

const LeaveRequestModal = ({ onClose, onSubmitted }) => {
  const todayIso = toISODate(new Date());
  const [form, setForm] = useState({
    data_od: todayIso,
    data_do: todayIso,
    typ: LEAVE_TYPES[0].value,
    notatka_pracownika: ''
  });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.data_od || !form.data_do || form.data_do < form.data_od) {
      toast.error('Sprawdz daty wniosku');
      return;
    }
    setBusy(true);
    try {
      await grafikService.submitMyLeave(form);
      toast.success('Wniosek zlozony');
      onSubmitted && onSubmitted();
      onClose && onClose();
    } catch (err) {
      toast.error(err.message || 'Blad skladania wniosku');
    } finally {
      setBusy(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '0.5rem',
    border: '1px solid var(--border)', borderRadius: '4px',
    backgroundColor: 'var(--card-bg)', color: 'var(--text)', fontSize: '0.9rem'
  };
  const labelStyle = {
    display: 'block', marginBottom: '0.25rem',
    fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)'
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1001
    }} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={{
        backgroundColor: 'var(--card-bg)', borderRadius: '8px',
        width: '100%', maxWidth: '480px',
        border: '1px solid var(--border)', boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
      }}>
        <div style={{
          padding: '1rem 1.25rem', borderBottom: '1px solid var(--border)',
          backgroundColor: 'var(--bg)',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center'
        }}>
          <h4 style={{ margin: 0, fontSize: '1rem', fontWeight: 600 }}>Zloz wniosek urlopowy</h4>
          <button onClick={onClose} style={{
            background: 'none', border: 'none', color: 'var(--text-muted)',
            fontSize: '1.2rem', cursor: 'pointer'
          }}>&#x2715;</button>
        </div>
        <form onSubmit={submit} style={{ padding: '1.25rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem', marginBottom: '0.75rem' }}>
            <div>
              <label style={labelStyle}>Data od</label>
              <input type="date" value={form.data_od}
                onChange={(e) => setForm(f => ({ ...f, data_od: e.target.value }))} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Data do</label>
              <input type="date" value={form.data_do}
                onChange={(e) => setForm(f => ({ ...f, data_do: e.target.value }))} style={inputStyle} />
            </div>
          </div>
          <div style={{ marginBottom: '0.75rem' }}>
            <label style={labelStyle}>Typ urlopu</label>
            <select value={form.typ}
              onChange={(e) => setForm(f => ({ ...f, typ: e.target.value }))} style={inputStyle}>
              {LEAVE_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
            </select>
          </div>
          <div style={{ marginBottom: '0.75rem' }}>
            <label style={labelStyle}>Notatka (opcjonalna)</label>
            <textarea rows={3}
              value={form.notatka_pracownika}
              onChange={(e) => setForm(f => ({ ...f, notatka_pracownika: e.target.value }))}
              style={{ ...inputStyle, resize: 'vertical' }} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', paddingTop: '0.5rem' }}>
            <button type="button" onClick={onClose}
              style={{
                padding: '6px 12px',
                border: '1px solid var(--border)', backgroundColor: 'var(--card-bg)',
                color: 'var(--text-secondary)', cursor: 'pointer', fontSize: '12px'
              }}>Anuluj</button>
            <button type="submit" disabled={busy}
              style={{
                padding: '6px 12px',
                backgroundColor: 'var(--info)', color: '#fff',
                border: 'none', cursor: 'pointer', fontSize: '12px', fontWeight: 600
              }}>{busy ? 'Wysylam...' : 'Zloz wniosek'}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LeaveRequestModal;
